export const programEventsCleaner = (name: string): string => {
  name = name.replaceAll(' ', '');
  name = name.replaceAll(/[\/&]/g, '');
  if (/^\d+$/.test(name[0])) {
    return name.replaceAll(/[0-9]/g, '');
  } else {
    return name;
  }
};
